"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ApprovalReportCDRowDTO_1 = require("../model/ApprovalReportCDRowDTO");

var ApprovalReportCDRowDTOConverter_1 = require("./ApprovalReportCDRowDTOConverter");
/**
 * @author Zdeněk Straka
 */


var ApprovalReportCDRowDTOConverterImpl =
/*#__PURE__*/
function (_ApprovalReportCDRowD) {
  _inherits(ApprovalReportCDRowDTOConverterImpl, _ApprovalReportCDRowD);

  function ApprovalReportCDRowDTOConverterImpl() {
    _classCallCheck(this, ApprovalReportCDRowDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ApprovalReportCDRowDTOConverterImpl).apply(this, arguments));
  }

  _createClass(ApprovalReportCDRowDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var kpis = {};

      if (source.kpiValues) {
        Object.keys(source.kpiValues).forEach(function (key) {
          var valueObj = source.kpiValues[key];

          if (valueObj && valueObj.value) {
            kpis[key] = conversions.toBigNumber(valueObj.value);
          } else if (valueObj) {
            kpis[key] = conversions.toBigNumber(valueObj);
          }
        });
      }

      return new ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO(ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.id.valueOf(conversions.documentToClassId(source)), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.nodeId.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.reportId.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.level.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.path.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.isGroup.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.entity.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.entityId.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.title.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.promotionCode.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.promotionName.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.storeSpecification.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.promoWorkflowState.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.windowWorkflowState.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.cd.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.cm.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.windowTypeId.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.windowTypeName.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.promoTypeId.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.promoTypeName.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.windowName.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.startWeekDate.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.daysValid.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.promoDiscount.valueOf(source.promoDiscount ? conversions.toBigNumber(source.promoDiscount) : null), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.workflowNote.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.windowsCount.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.skuCount.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.approveButtons.valueOfField(source), ApprovalReportCDRowDTO_1.ApprovalReportCDRowDTO.schema.kpiValues.valueOf(source.kpiValues ? kpis : null));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _a;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var kpiValues = (_a = source.kpiValues) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, cur, key) {
        acc[key] = conversions.fromBigNumber(cur);
        return acc;
      }, {});
      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        nodeId: source.nodeId,
        reportId: source.reportId,
        level: source.level,
        path: source.path,
        isGroup: source.isGroup,
        entity: source.entity,
        entityId: source.entityId,
        title: source.title,
        promotionCode: source.promotionCode,
        promotionName: source.promotionName,
        cd: source.cd,
        cm: source.cm,
        windowsCount: source.windowsCount,
        approveButtons: source.approveButtons,
        daysValid: source.daysValid,
        workflowNote: source.workflowNote,
        windowName: source.windowName,
        windowTypeId: source.windowTypeId,
        windowTypeName: source.windowTypeName,
        promoTypeId: source.promoTypeId,
        promoTypeName: source.promoTypeName,
        startWeekDate: source.startWeekDate ? conversions.fromDate(source.startWeekDate) : null,
        storeSpecification: source.storeSpecification,
        skuCount: source.skuCount,
        promoDiscount: source.promoDiscount ? conversions.fromBigNumber(source.promoDiscount) : null,
        kpiValues: kpiValues,
        promoWorkflowState: source.promoWorkflowState,
        windowWorkflowState: source.windowWorkflowState
      });
      return result;
    }
  }]);

  return ApprovalReportCDRowDTOConverterImpl;
}(ApprovalReportCDRowDTOConverter_1.ApprovalReportCDRowDTOConverter);

exports.ApprovalReportCDRowDTOConverterImpl = ApprovalReportCDRowDTOConverterImpl;